import React from 'react';
import RTModal from '../common/RTModal';
import RTButton from '../common/RTButton';
import './SendReminderModal.css';

const SendReminderModal = ({ show, onHide, onConfirm, selectedCount }) => {
  const footer = (
    <>
      <RTButton
        variant="secondary"
        onClick={onHide}
      >
       Cancel
      </RTButton>
      <RTButton
        variant="primary"
        onClick={onConfirm}
      >
        Confirm & Send
      </RTButton>
    </>
  );

  return (
    <RTModal
      isOpen={show}
      onClose={onHide}
      title="Send Payment Reminders"
      footer={footer}
      size="medium"
    >
      <div className="send-reminder-modal-content">
        <div className="reminder-info-message">
          <div className="info-icon">ℹ️</div>
          <div className="info-text">
            <p>
              Reminders will be sent only to invoices where the last WhatsApp message was sent 
              before the threshold days configured in WhatsApp settings.
            </p>
          </div>
        </div>
        
        <div className="reminder-summary">
          <div className="summary-item">
            <strong>Selected Invoices:</strong> {selectedCount}
          </div>
        </div>
        
        <div className="reminder-confirmation">
          <p>Are you sure you want to send payment reminders for the selected invoices?</p>
        </div>
      </div>
    </RTModal>
  );
};

export default SendReminderModal;
